import {
  AzureGroupInfoResponse,
  LessonNameAndType,
} from '@mnspro-cloud/services/lib/mnspro-cloud/api/v2';
import {
  CourseMapping,
  CourseMappingUpdateModel,
  ImportIssue,
  MappingsFilter,
} from '../CourseMapping.interfaces';
import { ActionTypes } from './CourseMapping.actiontypes';
import { Action } from './CourseMapping.redux.interfaces';

export const setTimetableCourses = (
  timetableCourses: LessonNameAndType[],
): Action<LessonNameAndType[]> => {
  return {
    type: ActionTypes.SetTimetableCourses,
    payload: timetableCourses,
  };
};

export const setCloudCourses = (
  cloudCourses: AzureGroupInfoResponse[],
): Action<AzureGroupInfoResponse[]> => {
  return { type: ActionTypes.SetCloudCourses, payload: cloudCourses };
};

export const SetInitialMappings = (
  mappings: CourseMapping[],
): Action<CourseMapping[]> => {
  return { type: ActionTypes.SetInitialMappings, payload: mappings };
};

export const updateSingleMapping = (
  updatedMapping: CourseMapping,
): Action<CourseMapping> => {
  return { type: ActionTypes.UpdateSingleMapping, payload: updatedMapping };
};

export const setErrorMessage = (
  errorMessage: string | null,
): Action<string | null> => {
  return { type: ActionTypes.SetErrorMessage, payload: errorMessage };
};

export const setMappingFilter = (
  mappingFilter: MappingsFilter,
): Action<MappingsFilter> => {
  return { type: ActionTypes.SetMappingFilter, payload: mappingFilter };
};

export const resetMappings = (): Action<null> => {
  return { type: ActionTypes.ResetMappings, payload: null };
};

export const setItemsPerPage = (itemsPerPage: number): Action<number> => {
  return { type: ActionTypes.SetItemsPerPage, payload: itemsPerPage };
};

export const setPage = (page: number): Action<number> => {
  return { type: ActionTypes.SetPage, payload: page };
};

export const setHasChanges = (hasChanges: boolean): Action<boolean> => {
  return { type: ActionTypes.SetHasChanges, payload: hasChanges };
};

export const importMappings = (
  updates: CourseMappingUpdateModel[],
): Action<CourseMappingUpdateModel[]> => {
  return { type: ActionTypes.ImportMappings, payload: updates };
};

export const setImportIssues = (issues: ImportIssue[]): Action<ImportIssue[]> => {
  return { type: ActionTypes.SetImportIssues, payload: issues };
};

export const setAllowMultipleAzureGroupUsage = (
  allowMultipleAzureGroupUsage: boolean,
): Action<boolean> => {
  return {
    type: ActionTypes.SetAllowMultipleAzureGroupUsage,
    payload: allowMultipleAzureGroupUsage,
  };
};
